import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import type {
  BaseQueryFn,
  FetchArgs,
  FetchBaseQueryError,
} from "@reduxjs/toolkit/query";

import { getExternalAddress } from "../../../../lib/url_utils";

export type BaseApiExtraOptions = {
  useAuth?: boolean;
};

// The store is still plain JS, so there's no canonical `RootState` to import.
// Narrow `api.getState()` to just the slice we care about here.
type StateWithAuth = {
  auth?: { accessToken?: string | null };
};

const rawBaseQuery = fetchBaseQuery({
  baseUrl: getExternalAddress(),
  timeout: 30_000,
});

const baseQuery: BaseQueryFn<
  string | FetchArgs,
  unknown, // response type - this is overridden per-endpoint via `builder.query<ResultType, Arg>`
  FetchBaseQueryError,
  BaseApiExtraOptions
> = async (args, api, extraOptions) => {
  const fetchArgs: FetchArgs = "string" === typeof args ? { url: args } : args;

  const { useAuth = true } = extraOptions ?? {};
  const state = api.getState() as StateWithAuth;
  const token = useAuth ? state.auth?.accessToken : null;

  if (!token) return rawBaseQuery(fetchArgs, api, extraOptions);

  const headers = new Headers(fetchArgs.headers as HeadersInit);
  headers.set("Authorization", `Bearer ${token}`);

  return rawBaseQuery({ ...fetchArgs, headers }, api, extraOptions);
};

export const baseApi = createApi({
  reducerPath: "baseApi",
  baseQuery,
  tagTypes: [],
  endpoints: () => ({}),
});
